import {Routes} from '@angular/router';
import {ViewAllEventsCalendarComponent} from './view-all-events-calendar.component';

export const ViewAllEventsCalendarRoutes: Routes = [
  {path: '', component: ViewAllEventsCalendarComponent}
];
